// Dynamic imports
const OnboardingView = () => import('@/views/onboarding/OnboardingView.vue')

export const onboardingRoutes = [
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: OnboardingView,
    meta: {
      title: 'Onboarding',
      requiresAuth: true,
      layout: 'blank'
    }
  }
]
